import { tv } from 'tailwind-variants';

const progressBarStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:w-full
      iris:flex-col
      iris:justify-start
    `,
        innerContainer: `
      iris:flex
      iris:w-full
      iris:items-center
      iris:gap-x-(--comp-space-gap-progress-bar-perc-text)
    `,
        base: `
      iris:relative
      iris:h-(--comp-size-box-progress-bar-medium)
      iris:grow
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-progress-bar)
      iris:bg-(--comp-color-background-progress-bar-default)
    `,
        indicator: `
      iris:h-full
      iris:rounded-(--comp-size-radius-progress-bar)
      iris:bg-(--comp-color-content-progress-bar-perc-bar)
      iris:transition-transform
      iris:duration-(--comp-motion-duration-progress-bar)
      iris:ease-(--comp-motion-easing-progress-bar)
    `,
        percentage: `
      iris:color-(--comp-color-content-progress-bar-perc-text)
      iris:w-9
      iris:font-(family-name:--comp-type-font-progress-bar-perc-text)
      iris:text-(length:--comp-type-size-progress-bar-perc-text)
      iris:leading-(--comp-type-leading-progress-bar-perc-text)
      iris:font-(--comp-type-weight-progress-bar-perc-text)!
    `,
        labelTag: `
      iris:cursor-default
      iris:font-(family-name:--comp-type-font-progress-bar-label)
      iris:text-(length:--comp-type-size-progress-bar-label)
      iris:leading-(--comp-type-leading-progress-bar-label)
      iris:font-(--comp-type-weight-progress-bar-label)!
      iris:tracking-(--comp-type-tracking-progress-bar-label)
      iris:text-(--comp-color-content-progress-bar-label)
      iris:hover:text-(--comp-color-content-progress-bar-label)
      iris:focus:text-(--comp-color-content-progress-bar-label)
      iris:focus-visible:text-(--comp-color-content-progress-bar-label)
      iris:active:text-(--comp-color-content-progress-bar-label)
    `,
    },
    variants: {
        inverse: {
            false: {},
            true: {
                base: "iris:bg-(--comp-color-background-progress-bar-inverse)",
                indicator: "iris:bg-(--comp-color-content-progress-bar-perc-bar-inverse)",
                percentage: "iris:text-(--comp-color-content-progress-bar-perc-text-inverse)",
                labelTag: `
          iris:text-(--comp-color-content-progress-bar-label-inverse)
          iris:hover:text-(--comp-color-content-progress-bar-label-inverse)
          iris:focus:text-(--comp-color-content-progress-bar-label-inverse)
          iris:focus-visible:text-(--comp-color-content-progress-bar-label-inverse)
          iris:active:text-(--comp-color-content-progress-bar-label-inverse)`,
            },
        },
        size: {
            md: {
                container: "iris:gap-y-(--comp-space-gap-progress-bar-label-md)",
                base: "iris:h-(--comp-size-box-progress-bar-medium)",
            },
            lg: {
                container: "iris:gap-y-(--comp-space-gap-progress-bar-label-lg)",
                base: "iris:h-(--comp-size-box-progress-bar-large)",
            },
        },
    },
    defaultVariants: {
        size: "md",
        value: 0,
    },
});

export { progressBarStyles as default };
